<template>
  <layout-default-appbar filterable :filters="filtros">
    Apontamento Embarque
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { MANUTENCAO_QUERIES } from '@/constants/QUERY_FILTERS';
import { MANUTENCAO_STORAGE } from '@/constants/STORAGE';
import { getQueryValue } from '@/services/query-string';
import geraData from '@/utils/geradata';

export default {
  name: 'ViewFrotaAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  computed: {
    filtros() {
      const hoje = geraData(new Date(), 'YYYY-MM-DD');
      const storageFrom = sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
      const storageBefore = sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
      const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

      const from = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || null);
      const before = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || null);
      const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);
      const lista = [];

      if (from && from !== hoje) lista.push(MANUTENCAO_QUERIES.createdFrom);
      if (before && before !== hoje) lista.push(MANUTENCAO_QUERIES.createdBefore);
      if (placa && placa !== 'null' && placa !== 'undefined') lista.push(MANUTENCAO_QUERIES.placa);

      return lista;
    },
  },
};
</script>
